/**
 * Layer B chat handoff. Reuse Discovery first-line machinery when the
 * thread is empty. Append an assistant line when talk already exists.
 * Never posts as a writer message.
 */
export function mergePathGapOpener({ messages = [], welcomeMessage = null, opener = '' } = {}) {
  const text = (opener || '').trim();
  if (!text) return { messages, welcomeMessage };
  if (!messages.length) {
    return { messages, welcomeMessage: text };
  }
  if (messages.some((row) => row.id === 'path-gap-opener')) {
    return { messages, welcomeMessage };
  }
  return {
    messages: [...messages, {
      id: 'path-gap-opener',
      speaker: 'assistant',
      content: text,
      // Same client stamp MessageList uses for the empty-thread welcome
      // line. ChatMessage formats created_at; a missing stamp is Invalid Date.
      created_at: new Date().toISOString(),
    }],
    welcomeMessage,
  };
}
